"use client";
import Image from "next/image";
import React from "react";

const CommonImage = ({ src, alt, className }) => {
    if (!src) return null; 
  return (
    <div className={`relative w-full h-full ${className}`} style={{ aspectRatio: "1/1" }}>
      <Image
        src={src}
        alt={alt}
        fill
        style={{ objectFit: "contain" }} 
        priority
      />
    </div>
  );
};

export default CommonImage;
